export const getPopupContentId = (popupId: string) => `${popupId}-content`
